import rootPath, { RouteProps as BaseRouteProps } from "../routes-path";

export interface RouteProps extends BaseRouteProps {
    idtClena: string;
}

export default rootPath + "/detailni-udaje-clena/:idtClena";